import { Columns } from '@shared/interfaces/table/column-config';
import { MeteringPointAdministrativePartyDto } from '@app/api/dmc';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

export const contactInformationMasterData: Columns<MeteringPointAdministrativePartyDto>[] = [
  {
    key: 'relationType',
    title: 'Adressetype',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      judicialaddress: 'meteringpoint.coredata.addresstypes.judicialaddress',
      technicaladdress: 'meteringpoint.coredata.addresstypes.technicaladdress',
    }
  },
  {
    key: 'name1',
    title: 'Kontaktnavn 1',
  },
  {
    key: 'name2',
    title: 'Kontaktnavn 2',
  },
  {
    key: 'phone',
    title: 'Telefon',
  },
  {
    key: 'mobile',
    title: 'Mobil',
  },
  {
    key: 'email',
    title: 'E-mail',
  },
  {
    key: 'protectedAddress',
    title: 'Hemmelig adresse',
  }
];
